import { Box, Button, HStack, Spinner, Text, VStack } from '@elkaso-app/web-design';
import { useGetRestaurantVaultApi } from 'apis/document-vault/use-get-restaurant-vault-api';
import { VaultCategorySection } from 'pages/restaurants/components/document-vault/vault-category-section';
import { VaultSummaryBar } from 'pages/restaurants/components/document-vault/vault-summary-bar';
import { FiArrowLeft } from 'react-icons/fi';
import { useHistory, useParams } from 'react-router-dom';

export const DocumentVaultScreen = () => {
  const { restaurantId } = useParams<{ restaurantId: string }>();
  const history = useHistory();
  const { data, isLoading } = useGetRestaurantVaultApi(restaurantId);

  const categories = data?.data?.categories ?? data?.categories ?? [];
  const summary = data?.data?.summary ?? data?.summary ?? {
    totalRequired: 0,
    totalUploaded: 0,
    totalExpired: 0,
    isComplete: false,
  };

  if (isLoading) {
    return (
      <Box display='flex' justifyContent='center' alignItems='center' minH='400px'>
        <Spinner size='lg' />
      </Box>
    );
  }

  return (
    <Box p='md'>
      <HStack mb='lg' spacing='md' align='center'>
        <Button
          variant='ghost'
          leftIcon={<FiArrowLeft />}
          onClick={() => history.push(`/app/restaurants/details/${restaurantId}`)}
          size='sm'>
          Back to Restaurant
        </Button>
        <Text fontSize='xl' fontWeight='bold'>
          Document Vault
        </Text>
      </HStack>

      <VaultSummaryBar summary={summary} />

      <VStack spacing='md' align='stretch'>
        {categories.length === 0 ? (
          <Box textAlign='center' py='xl'>
            <Text color='gray.500' fontSize='lg'>
              No documents configured yet
            </Text>
            <Text color='gray.400' fontSize='sm'>
              Document types need to be set up in the Document Types settings page
            </Text>
          </Box>
        ) : (
          categories.map((category: any) => (
            <VaultCategorySection key={category.category} category={category} restaurantId={restaurantId} />
          ))
        )}
      </VStack>
    </Box>
  );
};
